module.exports = __webpack_public_path__ + "static/media/advasonic-5.c55e9243.png";